/**
 * Re-enable a disabled user by typing their address.
 *
 * This control looks odd and exists for a measured reason: `auth.get_users` filters to enabled
 * users unconditionally — `enabled_only` is inert (spec §3.1) — so once someone is disabled, no
 * list anywhere can show them. `auth.update_user` addresses a user by email rather than a list
 * lookup, which is the one way back that does not need Frappe Desk.
 *
 * DELETE THIS COMPONENT once the ask in the spec's §7 lands and `get_users` honours
 * `enabled_only`; the table's own row can carry an Enable button then.
 */

import { useState } from 'react'
import { Button } from '../../../components/ui'
import { useUpdateUser } from '../../../lib/api/useUsers'

export function RestoreUserField() {
  const update = useUpdateUser()
  const [email, setEmail] = useState('')
  const [restored, setRestored] = useState('')

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        const addr = email.trim()
        if (addr === '' || update.isPending) return
        update.mutate(
          { email: addr, enabled: true },
          { onSuccess: (u) => { setRestored(u.email); setEmail('') } },
        )
      }}
    >
      <div style={{ color: 'var(--muted)', fontSize: 12.5, marginBottom: 8 }}>
        A disabled user disappears from the list above — the server cannot report them. Type their
        address to restore access. This is keyed on the address alone, so it re-enables ANY
        disabled Frappe user, not only someone disabled from this screen — a terminated
        employee's account or a service account included. Only type an address you mean to
        restore.
      </div>
      <div className="fieldrow">
        <label htmlFor="restore-email">Email</label>
        <input
          id="restore-email"
          type="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setRestored('') }}
          placeholder="colleague@example.com"
        />
      </div>
      <Button type="submit" disabled={email.trim() === '' || update.isPending}>
        {update.isPending ? 'Restoring…' : 'Restore access'}
      </Button>

      {restored !== '' && (
        <div style={{ fontSize: 12.5, marginTop: 8 }}>
          <b>{restored}</b> is enabled again and back in the list.
        </div>
      )}
      {update.isError && (
        <div style={{ color: 'var(--danger)', fontSize: 12.5, marginTop: 8 }}>
          {update.error instanceof Error ? update.error.message : 'Could not restore that user.'}
        </div>
      )}
    </form>
  )
}
